(() => {
  const hostSelector = 'csm-cookie-consent';
  const styleId = 'nd-consentmo-banner-overrides';
  const observedRoots = new WeakSet();

  const css = `
    .isense-cc-window .isense-cc-message,
    .isense-cc-window .isense-cc-compliance button {
      text-transform: none !important;
    }

    @media screen and (max-width: 749px) {
      .isense-cc-window .csm-cmp-body.isense-csm-cmp-body {
        padding: 16px !important;
        gap: 12px !important;
      }

      .isense-cc-window .csm-banner-text-wrapper,
      .isense-cc-window .isense-cc-message {
        margin: 0 !important;
      }

      .isense-cc-window .isense-cc-message,
      .isense-cc-window .isense-cc-link,
      .isense-cc-window .isense-cc-compliance button {
        font-size: 12px !important;
        line-height: 1.4 !important;
      }

      .isense-cc-window .cc-compliance.isense-cc-compliance {
        gap: 8px !important;
      }

      .isense-cc-window .cc-compliance.isense-cc-compliance > button.isense-cc-btn {
        height: 32px !important;
        min-height: 32px !important;
        padding: 4px 10px !important;
      }
    }
  `;

  function addStyles(root) {
    if (!root.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = css;
      root.append(style);
    }

    if (!observedRoots.has(root)) {
      const observer = new MutationObserver(() => {
        if (!root.getElementById(styleId)) addStyles(root);
      });

      observer.observe(root, { childList: true });
      observedRoots.add(root);
    }
  }

  function applyOverrides() {
    const root = document.querySelector(hostSelector)?.shadowRoot;
    if (!root) return false;

    addStyles(root);
    return true;
  }

  function waitForConsentmo() {
    if (applyOverrides()) return;

    let attempts = 0;
    const interval = window.setInterval(() => {
      attempts += 1;

      if (applyOverrides() || attempts >= 300) {
        window.clearInterval(interval);
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForConsentmo, { once: true });
  } else {
    waitForConsentmo();
  }

  document.addEventListener('consentmoSignal_onLoad', applyOverrides);
})();
